import React, { useEffect, useState } from 'react';
import {
    makeStyles,
    withStyles,
    DialogTitle,
    DialogContent,
    IconButton,
    Dialog,
    Slide,
    AppBar,
    Tabs,
    Tab,
    Box,
    Typography,
    Button,
    DialogActions
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { LandscapeIcon } from '../../../components/icons';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { SizeMe } from 'react-sizeme';
import { Document, Page, pdfjs } from 'react-pdf';
import { getCongineePdf, getConsignorPdf } from '../../../store/actions/tripActionCreator';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import * as logger from '../../../logger';

const useStyles = makeStyles((theme) => ({
    paper1: {
        borderRadius: 4
    },
    iconV1: {
        color: '#a9abaf'
    },
    iconButtonV1: {
        fontSize: 14,
        marginRight: 20
    },
    dialogTitleV1: {
        paddingRight: 4,
        paddingLeft: 4,
        paddingTop: 4,
        paddingBottom: '4px !important',
        boxShadow: '0 4px 4px 0 rgba(0, 13, 23, 0.06)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        '& .MuiTypography-root': {
            width: '100%'
        }
    },
    dialogContentV1: {
        paddingTop: 0,
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: '0px !important',
        backgroundColor: '#ececec'
    },
    dialogContentV2: {

    },
    iconV2: {
        fontSize: '26.15em'
    },
    widthV1: {
        width: 960,
        maxWidth: 960,
        height: 708
    },
    divV1: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%'
    },
    appBarV1: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: 'white',
        color: 'black',
        boxShadow: 'none',
        alignItems: 'center'
    },
    indicatorV1: {
        display: 'none'
    },
    tabRoot: {
        minHeight: '0px !important',
    },
    tabRootV1: {
        minHeight: '0px !important',
        minWidth: '0px !important',
        backgroundColor: '#efeff2',
        color: '#6b778c',
        borderRadius: '20px',
        fontSize: '14px',
        textTransform: 'capitalize'
    },
    tabSelected: {
        minHeight: '0px !important',
        minWidth: '0px !important',
        backgroundColor: '#E6F9FF',
        color: 'black',
        borderRadius: '20px',
        fontSize: '14px',
        textTransform: 'capitalize',
        border: '1px solid #5170f0'
    },
    tabRootV2: {
        marginLeft: 32
    },
    tabV1: {
        marginLeft: 8
    },
    daV1: {
        paddingLeft: 44,
        paddingRight: 44,
    },
    divActions: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    editButton: {
        color: '#5170f0',
        borderRadius: 4,
        border: '1px solid #5170f0',
        textTransform: 'capitalize',
        fontWeight: 500,
        paddingTop: 6,
        paddingBottom: 6,
        marginRight: 16
    },
    editIcon: {
        color: '#5170f0',
        fontSize: 16,
        marginRight: 8
    },
    downloadButton: {
        backgroundColor: '#5170f0',
        color: 'white',
        fontWeight: 500,
        borderRadius: 4,
        paddingTop: 6,
        paddingBottom: 6,
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#5170f0'
        }
    },
    tabPanel: {
        height: '100%',
        '& .MuiBox-root': {
            height: '100%'
        },
        '& .MuiTypography-root': {
            height: '100%'
        }
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const BiltyReportView = ({ open, onClose, onEdit, trip, pdfType, user, dipatchGetConsigneePdf, disptachGetConsignorPdf }) => {

    const classes = useStyles();

    const focusPdf = React.createRef();
    const [dialogOpen, setDialogOpen] = useState(open);
    const [value, setValue] = React.useState(0);
    const [congineePdf, setCongineePdf] = useState({});
    const [consignorPdf, setConsignorPdf] = useState({});
    const [pdfWidth, setPdfWidth] = useState(document.body.clientWidth - 35);
    const [numPages, setNumPages] = useState(null);

    const tripId = user && user.singleTripData && user.singleTripData.id ? user.singleTripData.id : "";

    useEffect(() => {

        dipatchGetConsigneePdf(
            tripId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Bilty Report View Dweb', "Get Consignee PDF successfull");
                    disptachGetConsignorPdf(
                        tripId,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log('Bilty Report View Dweb', "Get Consignor PDF successfull");
                            }
                        },
                        () => {
                            logger.log('Bilty Report View Dweb', "Get Consignor PDF successfull");
                        }
                    );
                }
            },
            () => {
                logger.log('Bilty Report View Dweb', "Get Consignee PDF failed");
            }
        );

    }, [open]);

    useEffect(() => {

        if (trip.congineePdf) {
            setCongineePdf(trip.congineePdf);
        }

        if (trip.consignorPdf) {
            setConsignorPdf(trip.consignorPdf)
        }

    }, [trip.congineePdf, trip.consignorPdf])

    useEffect(() => {

        if (pdfType == "consignor") {
            setValue(0);
        } else if (pdfType == "consignee") {
            setValue(1);
        }

    }, [pdfType])

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleEdit = () => {
        onEdit();
    }

    const handleDownload = () => {
        if (value == 0) {
            if (consignorPdf && consignorPdf.s3Link) {
                window.open(consignorPdf.s3Link);
            }
        } else if (value == 1) {
            if (congineePdf && congineePdf.s3Link) {
                window.open(congineePdf.s3Link);
            }
        }
    }

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box p={3}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    function onDocumentLoadSuccess({ numPages: nextNumPages }) {
        let header = document.getElementsByTagName('header')[0];
        if (header) {
            setPdfWidth(header.clientWidth - 60);
        }
        setNumPages(nextNumPages);
    }

    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

    return (
        <>
            <Dialog
                open={dialogOpen}
                fullWidth
                maxWidth={'lg'}
                TransitionComponent={Transition}
                keepMounted
                disableEscapeKeyDown={true}
                disableBackdropClick={true}
                onClose={handleClose}
                aria-labelledby=""
                aria-describedby="sim-tracking-pop-up-description"
                classes={{ paperScrollPaper: classes.paper1, paperWidthLg: classes.widthV1 }}
            >

                <DialogTitle className={classes.dialogTitleV1}>
                    <AppBar position="static" fullWidth classes={{ root: classes.appBarV1 }}>
                        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" classes={{ indicator: classes.indicatorV1, root: classes.tabRoot }} className={classes.tabRootV2} >
                            <Tab label="Consignor Copy" {...a11yProps(0)} classes={{ textColorInherit: classes.tabRootV1, selected: classes.tabSelected }} />
                            <Tab label="Consignee Copy" {...a11yProps(1)} classes={{ textColorInherit: classes.tabRootV1, selected: classes.tabSelected }} className={classes.tabV1} />
                        </Tabs>

                        <div>
                            <IconButton className={classes.iconButtonV1} onClick={handleClose}>
                                <CloseIcon className={classes.iconV1} />
                            </IconButton>
                        </div>
                    </AppBar>

                </DialogTitle>

                <DialogContent dividers className={classes.dialogContentV1}>

                    <TabPanel value={value} index={0} className={classes.tabPanel}>
                        {consignorPdf && consignorPdf.s3Link ? (
                            <>
                                <div className={classes.pdfContainer}>
                                    <div className={classes.pdfSubContainer} tabIndex={0} ref={focusPdf} >
                                        <SizeMe>
                                            {({ size }) => (
                                                <Document
                                                    file={consignorPdf && consignorPdf.s3Link ? consignorPdf.s3Link : null}
                                                    onLoadSuccess={onDocumentLoadSuccess}
                                                >
                                                    {
                                                        Array.from(
                                                            new Array(numPages),
                                                            (el, index) => (
                                                                <Page
                                                                    key={`page_${index + 1}`}
                                                                    pageNumber={index + 1}
                                                                    width={size.width ? size.width : 1}
                                                                />
                                                            ),
                                                        )
                                                    }

                                                </Document>
                                            )}
                                        </SizeMe>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className={classes.divV1}>
                                <LandscapeIcon className={classes.iconV2} />
                            </div>
                        )
                        }
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        {congineePdf && congineePdf.s3Link ? (
                            <>
                                <div className={classes.pdfContainer}>
                                    <div className={classes.pdfSubContainer} tabIndex={0} ref={focusPdf} >
                                        <SizeMe>
                                            {({ size }) => (
                                                <Document
                                                    file={congineePdf && congineePdf.s3Link ? congineePdf.s3Link : null}
                                                    onLoadSuccess={onDocumentLoadSuccess}
                                                >
                                                    {
                                                        Array.from(
                                                            new Array(numPages),
                                                            (el, index) => (
                                                                <Page
                                                                    key={`page_${index + 1}`}
                                                                    pageNumber={index + 1}
                                                                    width={size.width ? size.width : 1}
                                                                />
                                                            ),
                                                        )
                                                    }

                                                </Document>
                                            )}
                                        </SizeMe>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className={classes.divV1}>
                                <LandscapeIcon className={classes.iconV2} />
                            </div>
                        )}
                    </TabPanel>

                </DialogContent>

                <DialogActions className={classes.daV1} >
                    <div className={classes.divActions}>
                        <Button className={classes.editButton} variant="outlined" onClick={() => handleEdit()} >
                            <EditOutlinedIcon className={classes.editIcon} />
                            Edit
                        </Button>
                        <Button className={classes.downloadButton} variant="contained" onClick={() => handleDownload()} >
                            Download
                        </Button>
                    </div>
                </DialogActions>

            </Dialog>
        </>
    )
}




const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dipatchGetConsigneePdf: (tripId, onSuccess, onError) => {
        dispatch(getCongineePdf(tripId, onSuccess, onError))
    },
    disptachGetConsignorPdf: (tripId, onSuccess, onError) => {
        dispatch(getConsignorPdf(tripId, onSuccess, onError))
    }

});

export default connect(mapStateToProps, mapDispatchToProps)(BiltyReportView);